/**
 * Returns true when `parent` contains `child` (or they are the same node).
 * Safely handles `null`/`undefined` for either argument.
 */
export const contains = (parent: Node | null | undefined, child: Node | null | undefined): boolean => {
  if (!parent || !child) {
    return false;
  }
  return parent.contains(child);
};
